'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var IndexSection = require('components/IndexSection/IndexSection');

require('./IndexFreedom.less');


module.exports = IndexSection.extend({

    //is next section on show animation lies under or moves from outside
    NEXT_SECTION_MOVE: false,

    el: '.IndexFreedom',

    events: _.extend({

    }, IndexSection.prototype.baseEvents),


    initialize: function (options) {

        _.bindAll(this, 'onResourcesReady', 'onResize');

        if (app.settings.isDesktop) {
            if (Modernizr.webgl && !Modernizr.ieany) {
                this.effectLevel = 'webgl';

                this.resources = {
                    'displacement': app.staticPath + 'img/IndexFreedom/displacement.jpg',
                    'video': app.staticPath + 'img/IndexFreedom/road.mp4',
                };
            } else {
                this.effectLevel = 'video';

                this.resources = {
                    'video': app.staticPath + 'img/IndexFreedom/road.mp4',
                };
            }
        } else {
            this.effectLevel = 'photo';

            if (app.settings.isTablet) {
                this.resources = {
                    'photo': app.staticPath + 'img/IndexFreedom/road_tablet.jpg',
                };
            } else {
                this.resources = {
                    'photo': app.staticPath + 'img/IndexFreedom/road_phone.jpg',
                };
            }
        }

        this.$el.attr('data-effect', this.effectLevel);

        this.on('resources-ready', this.onResourcesReady);

        IndexSection.prototype.initialize.call(this, options);
    },


    onResourcesReady: function() {
        this.videoHandler = this.initVideo();
        // this.cursorHandler = this.initCursor();
    },


    show: function(params) {
        IndexSection.prototype.show.call(this, params);

        this.onResize();

        this.videoHandler.resume();
        // this.cursorHandler.resume();

        $(window).on('resize', this.onResize);
    },


    hide: function(params) {
        IndexSection.prototype.hide.call(this, params);

        this.hideInProgress = true;

        this.hideData = {
            direction: params.direction,
            startTime: +new Date(),
            endTime: +new Date() + (params.noAnimation ? 0 : this.ANIMATION_DURATION)
        }
    },


    onHideEnd: function(params) {
        this.videoHandler.pause();
        // this.cursorHandler.pause();

        this.hideInProgress = false;

        $(window).off('resize', this.onResize);
    },


    initVideo: function () {

        if (this.effectLevel == 'photo') {
            this.$('.IndexFreedom-video').css('background-image', 'url(' + this.resources['photo'] + ')');

            var paralaxHandler = this.initParallax();

            return {
                resume: function () {
                    paralaxHandler.resume();
                },
                pause: function () {
                    paralaxHandler.pause();
                }
            };
        }


        if (this.effectLevel == 'video') {
            var $video = $('<video class="What-video" width="100%" height="" muted playsinline crossorigin loop preload="auto"></video>');
            $video.attr('src', this.resources['video']);
            this.$('.IndexFreedom-video').append($video);

            var paralaxHandler = this.initParallax();

            return {
                resume: function () {
                    $video[0].play();

                    paralaxHandler.resume();
                },

                pause: function () {
                    $video[0].pause();

                    paralaxHandler.pause();
                }
            };
        }


        var self = this;
        var videoW = 1280;
        var videoH = 720;
        var animationFrame;

        var parallax = {
            x: 0,
            y: 0,
            targetX: 0,
            targetY: 0
        };


        var shaderBackward;

        var shaderDataBackward = [
            'precision mediump float;',

            'uniform float u_time;',
            'varying vec2 vTextureCoord;',
            'uniform sampler2D uSampler;',
            'uniform vec2 u_mapsSize;',
            'uniform vec4 filterArea;',

            'void main(){',
                'vec2 pos = vTextureCoord * filterArea.xy / u_mapsSize;',
                'float y = fract(pos.y * 5.0);',
                'vec4 c = vec4(0.0, 0.0, 0.0, 0.0);',
                'if (y > u_time) {',
                    'c=texture2D(uSampler,vTextureCoord);',
                '}',
                'gl_FragColor=c;',
            '}',
        ].join('\n');

        var shaderForward;

        var shaderDataForward = [
            'precision mediump float;',

            'uniform float u_time;',
            'varying vec2 vTextureCoord;',
            'uniform sampler2D uSampler;',
            'uniform vec2 u_mapsSize;',
            'uniform vec4 filterArea;',

            'void main(){',
                'vec2 pos = vTextureCoord * filterArea.xy / u_mapsSize;',
                'float y = fract(pos.y * 5.0);',
                'vec4 c = vec4(0.0, 0.0, 0.0, 0.0);',
                'if (y < 1.0 - u_time) {',
                    'c=texture2D(uSampler,vTextureCoord);',
                '}',
                'gl_FragColor=c;',
            '}',
        ].join('\n');

        var stage = new PIXI.Container();

        var renderer = new PIXI.autoDetectRenderer(videoW, videoH, {transparent: true});
        this.$('.IndexFreedom-video').append(renderer.view);

        var backgroundDisplacementTexture = PIXI.Texture.fromImage(this.resources['displacement']);
        var backgroundDisplacementSprite = new PIXI.Sprite(backgroundDisplacementTexture);
        var backgroundDisplacementFilter = new PIXI.filters.DisplacementFilter(backgroundDisplacementSprite, 0);
        stage.filters = [backgroundDisplacementFilter];

        var $video = $('<video muted playsinline crossorigin loop preload="auto"></video>');
        $video.attr('src', this.resources['video']);

        var videoTexture = PIXI.Texture.fromVideo($video[0]);
        var videoSprite = new PIXI.Sprite(videoTexture);
        videoTexture.baseTexture.source.loop = true;
        stage.addChild(videoSprite);

        videoTexture.baseTexture.autoPlay = false;


        var uniformsBackward = {};
        uniformsBackward.u_time = {type: 'float', value: 0.0};
        uniformsBackward.u_mapsSize = {type: 'vec2', value: {x: videoW, y: videoH}};
        shaderBackward = new PIXI.Filter(null, shaderDataBackward, uniformsBackward);

        var uniformsForward = {};
        uniformsForward.u_time = {type: 'float', value: 0.0};
        uniformsForward.u_mapsSize = {type: 'vec2', value: {x: videoW, y: videoH}};
        shaderForward = new PIXI.Filter(null, shaderDataForward, uniformsForward);


        function animate() {
            animationFrame = requestAnimationFrame(animate);

            stage.position.x = videoW / 2;
            stage.position.y = videoH / 2;

            stage.pivot.x = videoW / 2;
            stage.pivot.y = videoH / 2;

            parallax.x += .1 * (parallax.targetX - parallax.x);
            parallax.y += .1 * (parallax.targetY - parallax.y);

            stage.rotation = parallax.x * .04;

            //backgroundDisplacementFilter.scale.x = parallax.x * 50.5;
            backgroundDisplacementFilter.scale.y = parallax.y * 200.5;

            if (self.hideInProgress) {
                var curTime = + new Date();

                var percentage = (curTime - self.hideData.startTime) / (self.hideData.endTime - self.hideData.startTime);
                percentage = Math.min(Math.max(percentage, 0), 1);

                var easePercentage = window.app.easingFunctions(0, 1, percentage, 'easeInOutCubic');
                easePercentage = Math.min(Math.max(easePercentage, 0), 1);

                if (self.hideData.direction == 'backward') {
                    shaderBackward.uniforms.u_time = easePercentage;
                    stage.filters = [backgroundDisplacementFilter, shaderBackward];
                } else {
                    shaderForward.uniforms.u_time = easePercentage;
                    stage.filters = [backgroundDisplacementFilter, shaderForward];
                }


            } else {
                stage.filters = [backgroundDisplacementFilter];
            }

            renderer.render(stage);
        }


        function mousePosChanged(e) {
            parallax.targetX = e.pageX / (window.innerWidth / 2) - 1;
            parallax.targetY = e.pageY / (window.innerHeight / 2) - 1;
        }


        return {
            resume: function () {
                if (videoTexture.baseTexture.hasLoaded) {
                    $video[0].play();
                } else {
                    videoTexture.baseTexture.on('loaded', function() {
                        $video[0].play();
                    });
                }

                cancelAnimationFrame(animationFrame);

                $('body').on('mousemove', mousePosChanged);

                animate();
            },

            pause: function () {
                videoTexture.baseTexture.off('loaded');

                $video[0].pause();

                cancelAnimationFrame(animationFrame);

                $('body').off('mousemove', mousePosChanged);
            }
        };
    },


    onResize: function () {
        this.videoWidth = this.$('.IndexFreedom-video').width();
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    },


    initParallax: function () {

        var animationFrameId, stopTimeout,
            dxTarget = 0,
            prevX,
            dx = 0,
            dyTarget = 0,
            dy = 0,
            inertion = 0,
            tracking = false,
            self = this;


        return {
            resume: function () {
                if (app.settings.isDesktop) {
                    $('body').on('mouseenter', startTracking);
                    $('body').on('mouseleave', stopTracking);
                    $('body').on('mousemove', mousePosChanged);
                } else {
                    window.addEventListener('deviceorientation', orientationChanged, false);
                    startTracking();
                }
            },

            pause: function () {
                stopTracking();

                if (app.settings.isDesktop) {
                    $('body').off('mouseenter', startTracking);
                    $('body').off('mouseleave', stopTracking);
                    $('body').off('mousemove', mousePosChanged);
                } else {
                    window.removeEventListener('deviceorientation', orientationChanged, false);
                }
            }
        };


        function startTracking() {
            tracking = true;

            clearTimeout(stopTimeout);
            window.cancelAnimationFrame(animationFrameId);

            inertion = 0;
            applyParalax();

            function applyParalax() {
                dx += (dxTarget - dx) * inertion;
                dy += (dyTarget - dy) * inertion;

                self.dx = dx;
                self.dy = dy;

                inertion = Math.min(inertion + 0.01, 0.1);

                var xVideoShift = dx * (self.videoWidth - self.windowWidth - 4) / 3;
                var yVideoShift = dy * (self.videoWidth - self.windowWidth - 4) / 3;

                if (app.settings.isTablet) {
                    xVideoShift /= 1.5;
                    yVideoShift /= 1.5;
                }


                self.$('.IndexFreedom-video').css({
                    'transform': 'translate3d(' + -Math.round(xVideoShift * 10) / 10 + 'px, ' + -Math.round(yVideoShift * 10) / 10 + 'px, 0)'
                });

                animationFrameId = window.requestAnimationFrame(applyParalax);
            }
        }


        function stopTracking() {
            inertion = 0;
            tracking = false;
            window.cancelAnimationFrame(animationFrameId);
        }


        function orientationChanged(e) {
            switch (window.orientation) {
                case 0:
                    dyTarget = -(.02 * e.beta - .25 * Math.PI);
                    dxTarget = .03 * -e.gamma;
                    break;
                case 90:
                    dyTarget = -(.02 * -e.gamma - .25 * Math.PI);
                    dxTarget = .04 * -e.beta;
                    break;
                case -90:
                    dyTarget = -(.02 * e.gamma - .25 * Math.PI);
                    dxTarget = .04 * e.beta;
            }

            dyTarget > .8 ? dyTarget = .8 : dyTarget < -.8 && (dyTarget = -.8);
            dxTarget > .8 ? dxTarget = .8 : dxTarget < -.8 && (dxTarget = -.8);
            dy = dyTarget;
            dx = dxTarget;
        }


        function mousePosChanged(e) {
            dxTarget = e.pageX / (self.windowWidth / 2) - 1;
            dyTarget = e.pageY / (self.windowHeight / 2) - 1;

            prevX = e.pageX;

            if (!tracking) {
                startTracking();
            }
        }
    },

    /*initCursor: function () {
        var self = this;
        var animationFrame;

        var p1 = this.$('#glow-path')[0];
        var p2 = this.$('#stroke-path')[0];
        var maxPoints = 10;
        var points = [];
        var cnt = 0;

        function animate() {
            animationFrame = requestAnimationFrame(animate);

            cnt = (cnt + 1) % 2;

            !cnt && removePoint();
        }


        function removePoint() {
            if (points.length > 1) {
                points.shift();
                updatePoints();
            }
        }


        function updatePoints() {
            p2.setAttribute("stroke-width", points.length / maxPoints * 4.5);
            var pathD = 'M' + points.join(" ");
            p1.setAttribute("d", pathD);
            p2.setAttribute("d", pathD);
        }


        function mousePosChanged(e) {

            points.push([e.pageX, e.pageY]);

            if (points.length > maxPoints) {
                removePoint();
            } else {
                updatePoints();
            }

        }


        return {
            resume: function () {
                cancelAnimationFrame(animationFrame);

                $('body').on('mousemove', mousePosChanged);

                animate();
            },

            pause: function () {
                cancelAnimationFrame(animationFrame);

                $('body').off('mousemove', mousePosChanged);
            }
        };
    }*/
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexFreedom/IndexFreedom.js
 ** module id = 7
 ** module chunks = 0
 **/